angular.module('common.directives').directive('surfSnapshot', function () {
  return {
    scope: {
      imageData: '=',
      closeImage: '&'
    },
    templateUrl: './templates/surf-snapshot.view.html?t=' + window.webpackHash,
    link: function ($scope, $element) {},
    controller: 'surfSnapshotController'
  }
})
